import mod from "-!./Hours.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Hours.js?vue&type=script&lang=js&"